<template>
    <div class="page">
        <map-editor/>
        <editor type="region"/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import MapEditor from './_map'
import Editor from './_editor'
import API from '@/service/plate_editor'
export default {
    components: {
        MapEditor,
        Editor
    },
    computed: mapState({
        list: state => state.PlateEditor.list,
    }),
    async mounted () {
        const loading = this.$loading({
          lock: true,
          text: '请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        console.log(this.$route)
        const { plate_id } = this.$route.params
        const { data } = await API.getPlate(plate_id)
        setTimeout(() => {
            this.$store.dispatch('PlateEditor/openRegionEdit', data)
        }, 1500)
        loading.close()
        this.getPlates()
    },
    methods: {
        async getPlates () {
            const { data } = await API.getAllPlates()
            const { plate_id } = this.$route.params
            const items = data.items.filter(({ id }) => id != plate_id)
            console.log(items)
            setTimeout(() => {
                this.$store.dispatch('PlateEditor/addHelpRegion', items)
            }, 1500)
        }
    }
}
</script>
<style lang="scss" scoped>
.page {
    display: flex;
    width: 100%;
    height: 100vh;
}
</style>
